module.exports = __webpack_public_path__ + "static/media/tTab.58012927.png";